(function () {
  "use strict";

  function numberOnly() {
    /*@ngInject*/

    return {
      require: "ngModel",
      link: function (scope, element, attr, ngModelCtrl) {
        function fromUser(text) {
          if (text) {
            var transformedInput = text.replace(/[^1-9]/g, "");

            if (transformedInput !== text) {
              ngModelCtrl.$setViewValue(transformedInput);
              ngModelCtrl.$render();
            }
            return transformedInput;
          }
          return undefined;
        }
        ngModelCtrl.$parsers.push(fromUser);
      },
    };
  }

  angular.module("mandaeApp").directive("numbersOnly", numberOnly);
})();
